export const environment = {
    apiUrl:"https://shoppingtallydev.com/dev/shoppingtally-0.0.2-SNAPSHOT",
    socketUrl:"https://shoppingtallydev.com/dev/shoppingtally-0.0.2-SNAPSHOT"
};
